export function lowerCaseTrim(value: string) {
  const trimmed = value.trim();
  const lower = trimmed.toLowerCase();
  return lower;
}
